import reactWrapper from "@harbor/elements/utils/react/wrapper";
import { PropTypes } from "prop-types"; 
import { useI18n } from "../../../../i18n/useI18n";
import { createMarkup } from "../../../../utils/common";
const [HbrModal, HbrButton] =
    reactWrapper(["hbr-modal", "hbr-button"]);

const InsightsModal = (props) => { 
    const { tViews } = useI18n('views');
    const overlayDismiss = event => {
       event.preventDefault();
    }; 
    const onClickClose = () => {
        props.refNotificationInsightModal.current.element.hide();
        props.modalActionClose(false);
    }  
    return (
        <div>
            <HbrModal ref={props.refNotificationInsightModal} label={props.notificationMessage?.title} size="small" open={true} onHbr-overlay-dismiss={overlayDismiss} >				 
                <div className="insights-modal-content" dangerouslySetInnerHTML={createMarkup(props.notificationMessage?.message)}></div>
				<div slot="footer" style={{ textAlign: "center" }} >
					<HbrButton variant="text" onClick={onClickClose}>
						{tViews('notificationClose')}
					</HbrButton> 
				</div>
			</HbrModal> 
        </div>
    )
}

InsightsModal.propTypes = {
    refNotificationInsightModal: PropTypes.object,
    notificationMessage: PropTypes.object,
    modalActionClose: PropTypes.func
}
export default InsightsModal;